import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";

import Logo from './HomeComponents/logo';
import Articles from './HomeComponents/articles';
import SubscribeForm from './HomeComponents/subscribeform';
import { Mobile, NotMobile } from 'utils';

const useStyles = makeStyles((theme) => ({
    container: {
      width: "100%",
      height: "100%",
      color: "black"
    },
    content: {
        width: "100%",
        height: "100%",
        minWidth: "100%",
        minHeight: "calc(100vh - 65px)",
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    blog_card: {
        width: "100px",
        height: "100px",
        backgroundColor: "red"
    },
}))


const flairStyles = makeStyles((theme) => ({
    container: {
      width: "100vw",
      height: "47px",
      background: "#3571EB",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "white",
      fontFamily: "Lato",
      "&:hover": {
          cursor: "pointer",
          color: "darkgray"
      }
    },
    link: {
        textDecoration: "none",
        "&:visited": {
            color: "initial"
        }
    }
}))

function BlogFlair() {
    const classes = flairStyles();

    return (
        <Link to="/" className={classes.link}>
            <div className={classes.container}>Check out our Remote Policy Tracker Tool Here</div>
        </Link>
    )
}

const headerStyles = makeStyles((theme) => ({
    container: {
        height: "70px",
        width: "100%",
        backgroundColor: "white",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    },
    content: {
        height: "100%",
        width: "100%",
        maxWidth: "1100px",
        margin: "auto",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center"
    },
    logo: {

    },
    header_buttons: {

    },
    sub_button: {
        backgroundColor: "orange",
        color: "white",
        borderRadius: "8px",
        padding: "10px",
        border: "none",
        marginLeft: "60px"
    },
    mobileContent: {
        display: "flex",
        flexDirection: "column",
        margin: "auto",
        marginTop: "20px",
        alignItems: "center",
        width: "100%",
        padding: "0 15px"    
    },
    subscribe_input: {
        width: "120px",
        height: "30px",
        borderRadius: "8px",
        outline: "none"
    },
    mobile_header_buttons: {
        marginTop: "25px",
        width: "100%",
        display: "flex",
        justifyContent: "center"
    },
    mobile_sub: {
        marginLeft: "15px"
    },
    mobile_sub_input: {
        flexGrow: 1,
        paddingLeft: "10px",
        border: "1px solid black"
    }
}))

function BlogHeader() {
    const classes = headerStyles();

    return (
        <>
            <Mobile>
                <div className={classes.container}>
                    <div className={classes.mobileContent}>
                        <Logo linkToHome />
                        <div className={classes.mobile_header_buttons}>
                            <SubscribeForm />
                        </div>
                    </div>
                </div>
            </Mobile>
            <NotMobile>
                <div className={classes.container}>
                    <div className={classes.content}>
                        <Logo linkToHome style={{ marginTop: "-10px" }} />
                        <div className={classes.header_buttons}>
                            <SubscribeForm />
                        </div>
                    </div>
                </div>
            </NotMobile>
        </>
    )
}

export default function Blog({ }) {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <BlogFlair />
            <BlogHeader />
            <Articles />
        </div>
    )
}